var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 30.005,
    viewBox: "0 0 25 30.005",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25676",
    "data-name": "Grupo 25676",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69579",
    "data-name": "Trazado 69579",
    d: "M630.062,9.927h-12.5V8.677A6.25,6.25,0,0,1,629.281,5.65a1.25,1.25,0,1,0,2.186-1.214,8.75,8.75,0,0,0-16.4,4.241v1.78a6.25,6.25,0,0,0-3.75,5.72v7.5a6.258,6.258,0,0,0,6.25,6.25h12.5a6.258,6.258,0,0,0,6.25-6.25v-7.5A6.258,6.258,0,0,0,630.062,9.927Zm3.75,13.75a3.75,3.75,0,0,1-3.75,3.75h-12.5a3.75,3.75,0,0,1-3.75-3.75v-7.5a3.75,3.75,0,0,1,3.75-3.75h12.5a3.75,3.75,0,0,1,3.75,3.75Z",
    transform: "translate(-611.312 0.077)",
    fill: "#003763"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69580",
    "data-name": "Trazado 69580",
    d: "M804.562,298.667a1.25,1.25,0,0,0-1.25,1.25v2.5a1.25,1.25,0,0,0,2.5,0v-2.5A1.25,1.25,0,0,0,804.562,298.667Z",
    transform: "translate(-792.062 -281.162)",
    fill: "#003763"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoUnlock);
export default __webpack_public_path__ + "static/media/Icono-Unlock.bb84109327ff052d9a865a06524cb657.svg";
export { ForwardRef as ReactComponent };